import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ListScreen from '../../../components/listScreen/ListScreen';
import { VIEW_TYPE_SCREEN } from '../../../components/listScreen/ListScreen';

import {
  ROUTE_BACK_OFFICE_CONTENT_VALIDATOR_EDIT,
  ROUTE_BACK_OFFICE_CONTENT_VALIDATOR_NEW,
} from '../../../constants';
import { ENTITY_NAME_BACK_OFFICE_CONTENT_VALIDATOR } from '../../../dao/dbConstants';
import { setSearchParams } from '../../../redux/searchParamsSlice';

const ContentValidators = () => {
  const dispatch = useDispatch();
  const contentValidatorSearchParams = useSelector(
    (state) => state.searchParams.searchParams[ENTITY_NAME_BACK_OFFICE_CONTENT_VALIDATOR]
  );

  useEffect(() => {
    if (contentValidatorSearchParams?.pageSize !== 100) {
      dispatch(setSearchParams({
        entityName: ENTITY_NAME_BACK_OFFICE_CONTENT_VALIDATOR,
        searchParams: { pageSize: 100 },
      }));
    }
  }, [dispatch, contentValidatorSearchParams?.pageSize]);

  const rowActions = [];

  return (
    <ListScreen
      entityName={ENTITY_NAME_BACK_OFFICE_CONTENT_VALIDATOR}
      heading="Content Validators"
      showAddButton={true}
      addScreen={ROUTE_BACK_OFFICE_CONTENT_VALIDATOR_NEW}
      addScreenType={VIEW_TYPE_SCREEN}
      editScreen={ROUTE_BACK_OFFICE_CONTENT_VALIDATOR_EDIT}
      editScreenType={VIEW_TYPE_SCREEN}
      showSearch={true}
      rowActions={rowActions}
    />
  );
};

export default ContentValidators;